import * as z from "zod";

export const updateOnboardingV2Contacted = {
  name: "updateOnboardingV2Contacted" as const,
  input: z.object({
    teamId: z.string(),
    productId: z.string(),
    contacted: z.boolean(),
    contactedByEmail: z.string().optional(),
    contactedByName: z.string().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
